import Looks3RoundedIcon from "@mui/icons-material/Looks3Rounded";
import LooksOneRoundedIcon from "@mui/icons-material/LooksOneRounded";
import LooksTwoRoundedIcon from "@mui/icons-material/LooksTwoRounded";
import LoadingButton from "@mui/lab/LoadingButton";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import InputAdornment from "@mui/material/InputAdornment";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v5 as uuidv5 } from "uuid";
import { app } from "../config/firebase";
import { useAuth } from "../context/auth-context";
import { saveExperiment } from "../services/sandbox-api.service";

function CreateExperimentView() {

    const [folderName, setfolderName] = useState("");
    const [subfolderName, setsubfolderName] = useState("");
    const [usersFileName, setusersFileName] = useState("");
    const [iconFileName, seticonFileName] = useState("");
    const [uploadingFile, setuploadingFile] = useState(false);
    const [uploadIconFile, setuploadIconFile] = useState(false);
    const [savingData, setsavingData] = useState(false);
    const [expFileName, setexpFileName] = useState("");
    const [expName, setexpName] = useState("");
    const [expUrl, setexpUrl] = useState("");
    const [expLabel, setexpLabel] = useState("");
    const [activateExp, setactivateExp] = useState(false);
    const [openingType, setOpeningType] = useState();
    const [openingTypeLabel, setOpeningTypeLabel] = useState("Seleccione tipo de apertura");
    const [disableSubmit, setDisableSubmit] = useState(true);

    const navigate = useNavigate();

    const { user } = useAuth();

    const Input = styled("input")({
        display: "none",
    });

    useEffect(() => {
        const actualDate = Date.now();
        const uuidNanmeSpace = "727a545b-b476-4ebd-b905-bbf393d54113";
        const folderNameUuid = uuidv5(`${actualDate}`, uuidNanmeSpace);
        setfolderName(folderNameUuid);
        setsubfolderName(actualDate);
    }, []);

    useEffect(() => {
        if(expName == null || expName.length < 6) {
            setDisableSubmit(true);
        } 
        else if(expUrl == null || expUrl.length < 6) {
            setDisableSubmit(true);
        }
        else {
            setDisableSubmit(false);
        }
    },[expName, expUrl]);

    const handleChange = (event) => {
        if (event.target.name === "activateExp") {
            setactivateExp(event.target.checked);
        }
        if (event.target.name === "expName") {
            setexpName(event.target.value);
        }
        if (event.target.name === "expLabel") {
            setexpLabel(event.target.value);
        }
        if (event.target.name === "expUrl") {
            setexpUrl(event.target.value);
        }
    };

    const handleRadioChange = (event) => {
        if(event.target.name === "webview") {
            setOpeningType("webview");
            setOpeningTypeLabel("Web")
        } else {
            setOpeningType("native");
            setOpeningTypeLabel("Package")
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setsavingData(true);
        const payload = {
            name: expName,
            label: expLabel,
            openingType: openingType,
            link: expUrl,
            iconFile: iconFileName && iconFileName.length > 0 ? `${subfolderName}/${iconFileName}` : null,
            usersFile: expFileName && expFileName.length > 0 ? `${subfolderName}/${expFileName}`: null,
            folder: folderName,
            active: activateExp,
        };
        const response = await saveExperiment(user.accessToken, payload);
        setsavingData(false);
        if (response.data.experimentId) {
            navigate(`/experiments/detail/${response.data.experimentId}`);
        } else {
            console.log("ERROR ON SUBMIT DATA");
            console.log(response);
        }
    };

    const onUploadCsvFile = (e) => {
        const file = e.target.files[0];
        // Get a reference to the storage service, which is used to create references in your storage bucket
        const storage = getStorage(app);
        const fileName = `users.csv`;
        setexpFileName(fileName);
        // Create a storage reference from our storage service
        const storageRef = ref(
            storage,
            `public-sandbox-experiments/${folderName}/${subfolderName}/${fileName}`
        );
        // 'file' comes from the Blob or File API
        setuploadingFile(true);
        uploadBytes(storageRef, file)
            .then((snapshot) => {
                setuploadingFile(false);
                setusersFileName(file.name);
            })
            .catch((err) => {
                console.log("===ERROR UPLOAD===");
                console.log(err);
                setuploadingFile(false);
                setexpFileName("");
            });
    };

    const onUploadIconFile = (e) => {
        const file = e.target.files[0];
        // Get a reference to the storage service, which is used to create references in your storage bucket
        const storage = getStorage(app);
        const fileName = `${file.name}`;
        // Create a storage reference from our storage service
        const storageRef = ref(
            storage,
            `public-sandbox-experiments/${folderName}/${subfolderName}/${fileName}`
        );
        // 'file' comes from the Blob or File API
        setuploadIconFile(true);
        uploadBytes(storageRef, file)
            .then((snapshot) => {
                setuploadIconFile(false);
                seticonFileName(file.name);
            })
            .catch((err) => {
                console.log("===ERROR UPLOAD===");
                console.log(err);
                setuploadIconFile(false);
            });
    };

    return (
        <div className="container">
            <div className="form-exp-container">
                <div className="form-exp-title">Nuevo experimento</div>
                <div className="form-exp-container-inputs">
                    <div className="w-100p">
                        <TextField
                            className="w-100p"
                            required
                            id="outlined-required"
                            label="Name"
                            name="expName"
                            onChange={handleChange}
                            value={expName}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LooksOneRoundedIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className="form-exp-container-inputs__upload">
                        <TextField
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <LooksTwoRoundedIcon />
                                    </InputAdornment>
                                ),
                            }}
                            disabled
                            id="outlined-helperText"
                            label="Icono"
                            helperText="* Icono que se mostrará a la izquierda del Nombre"
                            className="pr-10 w-80p"
                            value={iconFileName}
                        />
                        <label htmlFor="contained-button-icon-file">
                            <Input
                                onChange={onUploadIconFile}
                                accept="image/png,image/jpeg"
                                id="contained-button-icon-file"
                                multiple
                                type="file"
                            />
                            <LoadingButton
                                loading={uploadIconFile}
                                variant="contained"
                                className="text-center"
                                component="span">
                                Subir
                            </LoadingButton>
                        </label>
                    </div>
                    <div className="w-100p">
                        <TextField
                            className="w-100p"
                            id="outlined-required"
                            label="Label"
                            name="expLabel"
                            onChange={handleChange}
                            value={expLabel}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Looks3RoundedIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className="form-exp-container-inputs__upload">
                        <TextField
                            disabled
                            id="outlined-helperText"
                            label="Archivo de usuarios"
                            helperText="* Archivo csv para la carga masiva de usuarios"
                            className="pr-10 w-80p"
                            value={usersFileName}
                        />
                        <label htmlFor="contained-button-file">
                            <Input
                                onChange={onUploadCsvFile}
                                accept="text/csv"
                                id="contained-button-file"
                                type="file"
                            />
                            <LoadingButton
                                loading={uploadingFile}
                                variant="contained"
                                className="text-center"
                                component="span">
                                Subir
                            </LoadingButton>
                        </label>
                    </div>
                    <div className="w-100p">
                        <RadioGroup
                            row 
                            onChange={handleRadioChange}
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group">
                            <FormControlLabel
                                value="webview"
                                name="webview"
                                control={<Radio />}
                                label="URL (WebView)"
                            />
                            <FormControlLabel
                                value="native"
                                name="native"
                                control={<Radio />}
                                label="Modulo Nativo"
                            />
                        </RadioGroup>
                        <TextField
                            disabled={openingType === null || openingType === undefined}
                            className="w-100p"
                            id="outlined-required"
                            label={openingTypeLabel}
                            name="expUrl"
                            onChange={handleChange}
                            value={expUrl}
                        />
                    </div>
                    <div className="w-100p">
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="activateExp"
                                        checked={activateExp}
                                        onChange={handleChange}
                                    />
                                }
                                label="Activar experimento"
                            />
                            <div className="helper-text">
                                * Se mostrará el experimento inmediatamente a
                                los usuarios cargados
                            </div>
                        </FormGroup>
                    </div>
                </div>
                <LoadingButton 
                    disabled={disableSubmit}
                    loading={savingData}
                    onClick={(e) => handleSubmit(e)}
                    variant="contained">
                    Crear expermiento
                </LoadingButton>
            </div>
            <div className="sandbox-imagen-container">
                <img
                    src="/images/sandbox.svg"
                    alt="sandbox imagen"
                    className="sandbox-imagen-container__imagen"
                />
            </div>
        </div>
    );
}

export default CreateExperimentView;
